import { describeScope } from "@/lib/reportScope";
import { fmtIST } from "@/lib/api";

// R17 - what the screen is ACTUALLY showing, from the `scope` block the response carries (never from the controls, which may have moved on): product scope (whole family with its member codes / exact
// code / all products), the IST date range with both end days included, the TEST rule, and the time the data was read. The drilldowns, the chart, the export and the AI summary use the same scope.
export function ReportScopeBanner({ scope, filters, testId = "reports-scope-banner" }) {
  const d = describeScope(scope);
  if (!d) return null;
  // R17 review F2: a caller / consultant / booking-source / owner selection either NARROWS this view (named, with what it means) or is declared NOT APPLICABLE - never silently dropped.
  const list = Array.isArray(filters) ? filters : [];
  return (
    <div className="space-y-1" data-testid={testId + "-wrap"}>
      <p className="text-xs rounded border bg-muted/40 px-3 py-1.5" data-testid={testId}>
        <b>Showing:</b> {d.product}{d.note ? ` — ${d.note}` : ""} · {d.dates} · {d.test}{d.asOf ? <> · data read <span data-testid={`${testId}-asof`}>{fmtIST(d.asOf)}</span></> : null}
      </p>
      {list.map((f) => (
        <p key={f.filter} data-testid={`${testId}-filter-${f.filter}`} className={`text-[11px] rounded border px-3 py-1 ${f.applied ? "bg-primary/5" : "border-amber-500/50 bg-amber-500/10"}`}>
          <b>{f.applied ? "Filter applied" : "Filter NOT applicable here"}:</b> {String(f.filter).replaceAll("_", " ")} = {f.label || f.value} ({f.meaning}) — {f.effect}
        </p>
      ))}
    </div>
  );
}
